import { Link, useLocation } from "react-router-dom";
import { Inbox, PenSquare, Newspaper, GraduationCap } from "lucide-react";

const ITEMS = [
  { to: "/admin/leads", label: "Leads Inbox", icon: Inbox, testId: "admin-nav-leads" },
  { to: "/admin/content", label: "Content Editor", icon: PenSquare, testId: "admin-nav-content" },
  { to: "/admin/blogs", label: "Blog Manager", icon: Newspaper, testId: "admin-nav-blogs" },
  { to: "/admin/enrollments", label: "Enrollments", icon: GraduationCap, testId: "admin-nav-enrollments" },
];

export function AdminNav() {
  const { pathname } = useLocation();
  return (
    <div className="mt-6 inline-flex rounded-full border border-border bg-white p-1 shadow-sm" data-testid="admin-nav">
      {ITEMS.map((item) => {
        const active = pathname.startsWith(item.to);
        return (
          <Link
            key={item.to}
            to={item.to}
            data-testid={item.testId}
            className={`flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors duration-200 ${
              active ? "bg-forest text-bone" : "text-foreground/60 hover:text-forest"
            }`}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </Link>
        );
      })}
    </div>
  );
}
